import Bundle from "../../../models/Bundle";

export function useCalculateMonthlyPayment(bundles: Bundle[]) {
  let monthlyPaymentTotal = 0;
  bundles?.forEach(bundle => {
    bundle.energyItems?.forEach(item => {
      monthlyPaymentTotal += item.monthlyPayment;
    })
  })

  return monthlyPaymentTotal;
}